import Vue from "vue";

Vue.filter("money", value => {
    value = (value / 100);

    if(value % 1 == 0) {
        value = value;
    }

    return new Intl.NumberFormat('ru-RU').format(value);
});

Vue.filter("shortMoney", value => {
    value = (value / 100);

    if(value >= 10000 && value < 1000000) {
        return parseInt(value / 1000) + "k";
    }

    if(value >= 1000000) {
        return parseInt(value / 1000000) + "kk";
    }

    return new Intl.NumberFormat('ru-RU').format(parseInt(value));
});

Vue.filter("currency", currency => {
    if(currency && currency.id) {
        return currency.symbol;
    }

    switch (currency) {
        case 978:
        case 'eur':
            return 'eur'
            break;
        case 840:
        case 'usd':
            return 'usd'
            break;
        case 980:
        case 'uah':
            return 'uah'
            break;
        case 643:
        case 'rub':
            return 'rub'
            break;
    }

    return '';
});